export enum RelatedVacanciesType {
    Similar = 'similar',
    Suitable = 'suitable',
}

export const RELATED_VACANCIES_TYPES = {
    SIMILAR: RelatedVacanciesType.Similar,
    SUITABLE: RelatedVacanciesType.Suitable,
};
